class ScrollLogo extends HTMLElement {
  connectedCallback() {
    this._update = this._update.bind(this);
    this._tick = this._tick.bind(this);
    this._onTransitionEnd = this._onTransitionEnd.bind(this);

    this._update();
    this._observer = new MutationObserver(this._update);
    this._observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style'],
    });

    this._initWordings();
  }

  disconnectedCallback() {
    this._observer?.disconnect();
    this._stopRotation();
  }

  _update() {
    const value = document.documentElement.style
      .getPropertyValue('--header-is-visible')
      .trim();
    this.toggleAttribute('visible', value === '0');
  }

  _initWordings() {
    const raw = (this.dataset.wordings || '').trim();
    if (!raw) return;

    this.wordings = raw
      .split(/\r?\n/)
      .map((s) => s.trim())
      .filter(Boolean);

    if (this.wordings.length === 0) return;

    this.slots = Array.from(this.querySelectorAll('.scroll-logo__rotor'));
    if (this.slots.length < 2) return;

    this._setText(this.slots[0], this.wordings[0]);
    this._setText(this.slots[1], this.wordings[1 % this.wordings.length]);

    this._activeIndex = 0;
    this._nextWordingIndex = 2 % this.wordings.length;

    if (this.wordings.length < 2) return;

    const interval = parseInt(this.dataset.interval, 10) || 4000;
    this._intervalId = setInterval(this._tick, interval);
  }

  _stopRotation() {
    if (this._intervalId) {
      clearInterval(this._intervalId);
      this._intervalId = null;
    }
  }

  _setText(slot, text) {
    const textPath = slot.querySelector('textPath');
    if (textPath) textPath.textContent = text;
  }

  _tick() {
    if (!this.slots || this._isAnimating) return;
    this._isAnimating = true;

    const current = this.slots[this._activeIndex];
    const incoming = this.slots[1 - this._activeIndex];

    this._animatingPair = { current, incoming };

    requestAnimationFrame(() => {
      current.classList.add('is-exiting');
      incoming.classList.add('is-entering');
    });

    current.addEventListener('transitionend', this._onTransitionEnd);
  }

  _onTransitionEnd(e) {
    if (e.propertyName !== 'opacity') return;
    const { current, incoming } = this._animatingPair;
    current.removeEventListener('transitionend', this._onTransitionEnd);

    current.classList.add('no-transition');
    incoming.classList.add('no-transition');

    current.classList.remove('scroll-logo__rotor--current', 'is-exiting');
    current.classList.add('scroll-logo__rotor--incoming');

    incoming.classList.remove('scroll-logo__rotor--incoming', 'is-entering');
    incoming.classList.add('scroll-logo__rotor--current');

    this._setText(current, this.wordings[this._nextWordingIndex]);
    this._nextWordingIndex = (this._nextWordingIndex + 1) % this.wordings.length;
    this._activeIndex = 1 - this._activeIndex;

    void this.offsetWidth;

    requestAnimationFrame(() => {
      current.classList.remove('no-transition');
      incoming.classList.remove('no-transition');
      this._isAnimating = false;
    });
  }
}

if (!window.customElements.get('scroll-logo')) {
  window.customElements.define('scroll-logo', ScrollLogo);
}
